import { actionTypes } from "../actions/store";
import { actionTypes as authActionTypes } from '../actions/auth'

let sessionInfo = JSON.parse(localStorage.getItem('storeInfo'))

const initialState = {
    id: null,
    primaryColor: null, 
    secondaryColor: null,
    storeName: null,
    storeLogo: null,
    flags: {
        ErpVoceQpad: null,
        ErpEcomanda: null,
        ErpBematech: null,
        Delivery: null,
        Giraffas: null,
        Kilo: null,
        Colibri: null
    }
}

const storeInfoReducer = (state = sessionInfo || initialState, action) => {
  let newState = state;
  switch (action.type) {
    case actionTypes.SET_STORE_INFORMATION: {
      newState = action.payload;
      break;
    }
    case authActionTypes.LOGOUT: {
      newState = null
      break;
    }
    default: {
      newState = state;
      break;
    }
  }
  if (newState) {
    localStorage.setItem('storeInfo', JSON.stringify(newState));
  } else {
    localStorage.removeItem('storeInfo')
  }
  return newState
};

export default storeInfoReducer;
